import { useEffect } from 'react';
import { assignmentsGet } from 'core/store/modules/common/actions';

import initAssignment from '../utils/init-assignment';

export default ({ dispatch, id, root, setEditAssignment }: any) => {
  useEffect(() => {
    dispatch(assignmentsGet(id));
    setEditAssignment({ ...initAssignment(id, root) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
};
